const alertTimesData = [
	{
		name: "A Tiempo",
		time: 0,
		color: "green",
	},
	{
		name: "En Atraso",
		time: 5,
		color: "orange",
	},
	{
		name: "Vencido",
		time: 10,
		color: "red",
	},
];
export default alertTimesData;
